import { cn } from '../../utils/cn'
import { AtLinkButtonVariants } from './index'

const atLinkButtonVariants: Record<AtLinkButtonVariants, string> = {
  'button-primary-dark': cn(
    'bg-neutrals-white text-primary-500 gap-2',
    'font-regular text-14 leading-1.375 tracking-widest text-center',
    'slg:h-14 slg:py-2 slg:px-8',
    'h-10 py-1 px-4',
    'hover:bg-primary-100 hover:text-primary-700',
    'active:bg-primary-300 active:text-primary-700',
    'disabled:bg-neutrals-700 disabled:text-neutrals-white',
    'focus:outline focus:outline-offset-2 focus:outline-2 focus:outline-neutrals-black'
  ),
  'button-primary-light': cn(
    'bg-primary-500 text-neutrals-white gap-2',
    'font-regular text-14 leading-1.375 tracking-widest text-center',
    'slg:h-14 slg:py-2 slg:px-8',
    'h-10 py-1 px-4',
    'hover:bg-primary-700',
    'active:bg-primary-900',
    'disabled:bg-neutrals-500',
    'focus:outline focus:outline-offset-2 focus:outline-2 focus:outline-neutrals-black'
  ),
}

export const getAtLinkButtonVariant = (variant: AtLinkButtonVariants) => {
  return atLinkButtonVariants[variant ? variant : 'button-primary-dark']
}
